import { useMemo } from "react";
import { Grid, Typography, styled } from "@mui/material";

import { IContent } from "@vmosolutions/oc-interfaces";

import OcTurbineIcon from "src/themes/assets/oc-turbine.svg?react";
import { formatDateString } from "../DateDisplay";

interface IFooterProps {
  content: IContent;
}

const OCDraggableArea = styled(Grid)(({ theme }) => ({
  float: "right",
  width: "auto",
  "& .body": {
    color: theme.custom.forms.focusedColor,
    fontSize: 12,
    fontWeight: 300,
    textAlign: "right",
    padding: "2px 0px",
    opacity: 0.5,
    userSelect: "none",
  },
}));

/**
 * CMS Footer - Displays Last Edited By, Last Edited Date, Created By, Created Date, Source. Present in edit content 'state.'
 * Display source = if icon present, display icon, else display 'source: content source name'
 * @param props - content
 */
export const Footer = (props: IFooterProps): JSX.Element => {
  const { content } = props;

  const sourceIcon = useMemo((): JSX.Element => {
    switch (content?.source?.iconName) {
      case "OC":
        return (
          <Grid container alignItems="center">
            <Typography>Source: OC</Typography>
            <Grid item sx={{ marginLeft: "10px", svg: { width: "40px", height: "40px", path: { fill: "white" } } }}>
              <OcTurbineIcon />
            </Grid>
          </Grid>
        );
      default:
        return <Typography>Source: {content?.source?.name}</Typography>;
    }
  }, [content]);

  const createdBy = useMemo(() => {
    return content?.uploadedBy ? "" : content?.source?.name;
  }, [content]);

  return (
    <Grid container style={{ width: "100%", marginTop: 20 }} justifyContent="flex-end">
      {sourceIcon && (
        <Grid className="body" style={{ marginRight: 20 }}>
          {sourceIcon}
        </Grid>
      )}
      <OCDraggableArea container direction="column">
        {!!content?.modifiedAt && (
          <Typography className="body">
            Last Modified {formatDateString(content?.modifiedAt, "Etc/UTC", true)}
          </Typography>
        )}
        <Typography className="body">
          Created by {createdBy} on {formatDateString(content?.createdAt, "Etc/UTC", true)}
        </Typography>
      </OCDraggableArea>
    </Grid>
  );
};
